<script lang="ts">
  import { RICH_TOOLTIP_CLASS, tooltip } from "@kontextwerk/web-sdk/core/overlay/tooltip"
  import { escapeHtml } from "@kontextwerk/web-sdk/core/security"
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"

  let {
    text = "",
    tagLabel = null,
    disabled = false,
  }: {
    text?: string
    tagLabel?: string | null
    disabled?: boolean
  } = $props()

  const label = $derived(String(text || "").trim() || "Nicht genannt")
  const compactLabel = $derived(label.length > 54 ? `${label.slice(0, 51).trimEnd()}…` : label)
</script>

{#if tagLabel}
  <span class="inbox-statement-tag" class:disabled>
    <StatusTag
      variant="neutral"
      size="sm"
      label={tagLabel}
      subLabel={compactLabel}
      color="teal"
      tooltipContent={label}
      disableTitle={true}
    />
  </span>
{:else}
  <span
    class="inbox-statement-cell"
    class:disabled
    use:tooltip={{ content: escapeHtml(label), className: RICH_TOOLTIP_CLASS }}
  >
    {label}
  </span>
{/if}

<style>
  .inbox-statement-tag {
    display: inline-flex;
    max-width: 18rem;
  }

  .inbox-statement-cell {
    color: var(--text-invers-100);
    display: inline-block;
    line-height: 1.25;
    max-width: 18rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .inbox-statement-tag.disabled,
  .inbox-statement-cell.disabled {
    opacity: 0.62;
  }
</style>
